import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { getActiveMetricsContext, trackEvent } from '@src/metrics';
import { openActivateSubscriptionModal } from '@src/redux/actions/subscription';
import './styles.scss';

const SubscriptionNoticeWrapper = ({ status, text, openActivateSubscriptionModal }) => {
  const location = useLocation();

  const pathname = location.pathname;

  function openSubscriptionModal() {
    openActivateSubscriptionModal();

    trackEvent({
      context: MetricContext.ACTIVATE_SUBSCRIPTION,
      interaction: MetricAction.OPEN_ACTIVATE_SUBSCRIPTION,
      payload: {
        'Event Source': MetricEventSource.TOP_NOTICE_BAR,
        'Previous Context': getActiveMetricsContext(pathname),
      },
    });
  }

  return (
    <div className="subscription-notice" onClick={openSubscriptionModal}>
      <span className="subscription-notice__text">
        <strong> {status} </strong> {text}
      </span>

      <span className="subscription-notice__button">Subscribe</span>
    </div>
  );
};

SubscriptionNoticeWrapper.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  openActivateSubscriptionModal: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

SubscriptionNoticeWrapper.defaultProps = {
  text: 'Subscribe and get access to the full platform.',
};

export default connect(null, {
  openActivateSubscriptionModal,
})(SubscriptionNoticeWrapper);
